import { render } from "./WhoWeAre.vue?vue&type=template&id=501dca69&scoped=true"
import script from "./WhoWeAre.vue?vue&type=script&lang=js"
export * from "./WhoWeAre.vue?vue&type=script&lang=js"

import "./WhoWeAre.vue?vue&type=style&index=0&id=501dca69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501dca69"]])

export default __exports__